import { render, staticRenderFns } from "./DetailPhones.vue?vue&type=template&id=d985adfe&"
import script from "./DetailPhones.vue?vue&type=script&lang=js&"
export * from "./DetailPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports